import { UtilityService } from './index'

class StyleServices {
    async listStyles(page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/styles', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getStylePrefilledData() {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getStyle', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        })
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async removeStyle(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/style', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleId: id
            })
        });
        return {
            text: await result.json(),
            status: result.status,
        };
    }

    async imageUpload(value) {

        var formData = new FormData();
        // formData.append("refImage",value)
        // for (let i = 0; i < value.length; i++) {
        formData.append("referenceImages", value)
        formData.append("fileType", 'fabric')

        // }
        let result = await fetch(UtilityService.baseUrl() + 'api/style/uploadReferenceSketch', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: formData
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getStyleOrigination(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/getStyleOrigination', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: ""
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async getActionedBy(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style//getActionedBy', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: value
            })
        });
        return result.json();
    }

    async  createStyle(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/saveStyle', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            text: await result.json(),
            status: result.status
        };
    }


    async createReference(data) {

        let result = await fetch(UtilityService.baseUrl() + 'api/style/saveOption', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async deleteReference(styleId, referenceId) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/option', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleId: styleId,
                referenceId: referenceId
            })
        });
        return {
            text: await result.json(),
            status: result.status
        };
    }

    async deleteReference1(styleId, referenceId) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/deleteReference', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleId: styleId,
                referenceCode: referenceId
            })
        });
        return {
            text: await result.json(),
            status: result.status
        };
    }

    async listIB(referenceId, page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/IBList', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleReferenceId: referenceId,
                page: page
            })
        });

        return {
            status: result.status,
            text: await result.json()
        };
    }

    async listSMV(referenceId, page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/SMV', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleReferenceId: referenceId,
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async listThreadConsumption() {

        let result = await fetch(UtilityService.baseUrl() + 'api/style/threadConsumptions', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                magnumStyleId: localStorage.getItem("styleId"),
                styleReferenceId: localStorage.getItem("referenceId")
            })
        });
        return result.json();
    }

    async prefillSMVInfo() {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/SMVDetails', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async createSMV(fullInfo) {

        let result = await fetch(UtilityService.baseUrl() + 'api/style/AddSMV', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(fullInfo)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async editSMV(fullInfo) {

        let result = await fetch(UtilityService.baseUrl() + 'api/style/editSMV', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                magnumStyleId: localStorage.getItem("styleId"),
                styleReferenceId: localStorage.getItem("referenceId"),
                smvId: fullInfo.smvId,
                sampleType: fullInfo.sampleType,
                sampleDate: fullInfo.sampleDate,
                size: fullInfo.size,
                chartPreparedOn: fullInfo.chartPreparedOn,
                data: fullInfo.data,
            })
        });
        return result.json();
    }

    async removeSmv(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/SMV', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                smvId: id
            })
        });
        return result.json();
    }


    async getSMV(id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/style/getSMV', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                smvId: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getSMVCustomerData(customerId, departmentId) {

        let result = await fetch(UtilityService.baseUrl() + 'api/style/getSMVCustomerData', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                customerId,
                departmentId
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async removeThread(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/ThreadConsumption', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                tcId: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async getSpecificThread(id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/style/getThreadConsumption', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                tcId: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async createThread(fullData) {

        let result = await fetch(UtilityService.baseUrl() + 'api/style/AddThreadConsumption', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(fullData)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }



    async editThread(fullData) {

        let result = await fetch(UtilityService.baseUrl() + 'api/style/editThreadConsumption', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                tcId: fullData.threadId !== undefined ? fullData.threadId : "",
                magnumStyleId: localStorage.getItem("styleId"),
                styleReferenceId: localStorage.getItem("referenceId"),
                sampleType: fullData.threadInfo.sampleType !== undefined && fullData.threadInfo.sampleType.name !== undefined ? fullData.threadInfo.sampleType._id : fullData.threadInfo.sampleType,
                sampleDate: fullData.threadInfo.sampleDate,
                size: fullData.threadInfo.size,
                chartPreparedOn: fullData.threadInfo.chartPreparedOn,
                data: fullData.threadCount,
                wastage: fullData.wastage,
                otherSizes: fullData.otherSizes

            })
        });
        return result.json();
    }

    async createTechnicalIssue(fullData) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/technicalIssue', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(fullData)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }
    async getStyleInfo(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/getStyle', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async getReferenceInfo(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/getReferenceById', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                referenceId: id
            })
        });
        return result.json();
    }

    async searchStylesBy(searchBy, searchVal, page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/searchStyleslist', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: searchVal,
                by: searchBy,
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async searchCosting(costingBy, costingVal) {
        let result = await fetch(UtilityService.baseUrl() + 'api/costing/searchCostinglist', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: costingVal,
                by: costingBy
            })
        });
        return result.json();
    }
    async getSampleRequest(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/getSRByReference', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                referenceId: id
            })
        });
        return result.json();
    }

    //QRCode for reference
    async getQRCodeForReferenceStyle(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/generateQrOptions', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleId: id
            })
        })
        return {
            text: await result.json(),
            status: result.status,
        };
    }

    //QRCode for reference
    async getOptionsStyle(styleId, referenceId) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/getOptionsStyle', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleId: styleId,
                referenceId: referenceId
            })
        })
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //saveIb
    async saveIB(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/saveStyleInfo', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(
                data
            )
        })
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //listStyleSubModule
    async listStyleSubModule(moduleLink, page) {
        let result = await fetch(UtilityService.baseUrl() + `api/style/${moduleLink}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: page
            })
        })
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //search Style
    async SearchStyle(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/Search', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleNumber: value
            })
        })
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //Bnumber
    //Show Predefind values (Types Of Test, Greige Mill  ,Process Mill )
    async getBNumberPrefilldData() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/getBNumberPrefilledData', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            // body : JSON.stringify({
        })
        //     styleNumber : value
        // })
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async searchFilterForStyleNumber(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/development/getStyleByRange', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem('authToken')
            },
            body:
                JSON.stringify(data)
        });
        return result.json();
    }


    async getStyleInfoByReference(id) {

        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getSampleRequestByStyle', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                "referenceId": id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }
    async getTechnicalIssues(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/getTechnicalIssue', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                "_id": id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }
    async getSampleType() {
        let result = await fetch(UtilityService.baseUrl() + 'api/system/Systemstyles', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                heading: "STYLE",
                subHeading: "SAMPLETYPE"
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getSMVByRefId(referenceId) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/SMV', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleReferenceId: referenceId
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async searchSMVList(searchBy, searchVal, page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/searchSMVlist', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: searchVal,
                by: searchBy,
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async listTI(referenceId, page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/techIssueList', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                styleReferenceId: referenceId,
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async removeTechIssue(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/techIssue', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async searchTIlist(searchBy, searchVal, page) {
        let result = await fetch(UtilityService.baseUrl() + 'api/style/searchTIlist', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                for: searchVal,
                by: searchBy,
                page: page
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

}
export default new StyleServices();


// WEBPACK FOOTER //
// ./src/services/style.service.js